import { useState, useEffect } from 'react';

interface ViewportHookResult {
  isMobileWidth: boolean;
  breakpoint: number;
}

export const useBreakpoint = (
  breakpoint: number,
  initialViewportWidth?: number
): ViewportHookResult => {
  const initialState = initialViewportWidth ? initialViewportWidth < breakpoint : false;
  const [isMobileWidth, setIsMobileWidth] = useState(initialState);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (e: MediaQueryListEvent) => {
      setIsMobileWidth(e.matches);
    };

    mediaQuery.addEventListener('change', handler);
    setIsMobileWidth(mediaQuery.matches);

    return () => mediaQuery.removeEventListener('change', handler);
  }, [breakpoint]);
  return { isMobileWidth, breakpoint };
};